var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(180 48 48)",
    fill: "url(#paint0_linear_3574_34450)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4142 31.4142C26.6332 32.1953 25.3668 32.1953 24.5858 31.4142L18.5858 25.4142C17.8047 24.6332 17.8047 23.3668 18.5858 22.5858L24.5858 16.5858C25.3668 15.8047 26.6332 15.8047 27.4142 16.5858C28.1953 17.3668 28.1953 18.6332 27.4142 19.4142L22.8284 24L27.4142 28.5858C28.1953 29.3668 28.1953 30.6332 27.4142 31.4142Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3574_34450",
    x1: 49.4118,
    y1: 52.2,
    x2: 98.275,
    y2: 86.8728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftEnabled);
export default __webpack_public_path__ + "static/media/left-enabled.ef2dccee.svg";
export { ForwardRef as ReactComponent };